﻿class ImageMagnifier extends HTMLElement {
  connectedCallback() {
    this.img = this.querySelector('img');
    if (!this.img) return;

    this.lens = document.createElement('div');
    this.lens.className = 'magnifier-lens';
    this.appendChild(this.lens);

    this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.addEventListener('mousemove', this.handleMouseMove.bind(this));
    this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
  }

  handleMouseEnter(e) {
    if (window.innerWidth < 750) return;
    this.img = this.querySelector('img');
    if (!this.img) return;

    const src = this.img.getAttribute('data-max-resolution') || this.img.src;
    this.lens.style.backgroundImage = `url("${src}")`;
    this.lens.style.display = 'block';
    this.updateZoom(e);
  }

  handleMouseMove(e) {
    if (window.innerWidth < 750) return;
    requestAnimationFrame(() => this.updateZoom(e));
  }

  handleMouseLeave() {
    this.lens.style.display = 'none';
  }

  updateZoom(e) {
    if (!this.img) return;

    const rect = this.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const lensWidth = this.lens.offsetWidth || 160;
    const lensHeight = this.lens.offsetHeight || 160;

    const lensX = x - lensWidth / 2;
    const lensY = y - lensHeight / 2;

    this.lens.style.left = `${lensX}px`;
    this.lens.style.top = `${lensY}px`;

    const bgX = (x / rect.width) * 100;
    const bgY = (y / rect.height) * 100;

    const zoomLevel = 2.5;
    this.lens.style.backgroundSize = `${rect.width * zoomLevel}px ${rect.height * zoomLevel}px`;
    this.lens.style.backgroundPosition = `${bgX}% ${bgY}%`;
  }
}

if (!customElements.get('image-magnifier')) {
  customElements.define('image-magnifier', ImageMagnifier);
}